import React, { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ADMIN_CREDENTIALS } from "../config/admin";

const adminUser = process.env.REACT_APP_ADMIN_USERNAME;
const adminPass = process.env.REACT_APP_ADMIN_PASSWORD;

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedAdmin = sessionStorage.getItem("admin");
    if (storedAdmin) {
      setAdmin(JSON.parse(storedAdmin));
    }
  }, []);

  const login = (username, password) => {
    // Hardcoded credentials (change as needed)
    //if (username === ADMIN_CREDENTIALS.username && password === ADMIN_CREDENTIALS.password) {
    if (username === adminUser && password === adminPass) {
      const adminData = { username, role: "admin" };
      setAdmin(adminData);
      sessionStorage.setItem("admin", JSON.stringify(adminData));
      navigate("/admin/dashboard");
      return true;
    }
    return false;
  };

  const logout = () => {
    setAdmin(null);
    sessionStorage.removeItem("admin");
    navigate("/admin");
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};